import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectPreviousAction, selectNextAction } from 'redux/reducers/calendar/actions'
import dayjs from 'dayjs'

const prevNav = (date, firstAvailableDate) => {
  const prevMonth = dayjs(date).subtract(1, 'month').format('YYYY-MM-DD')

  if (dayjs(prevMonth).isBefore(firstAvailableDate, 'month')) {
    return ['Calendar-nav--button--unavailable']
  }

  return []
}

const nextNav = (date, lastAvailableDate) => {
  const nextMonth = dayjs(date).add(1, 'month').date(1).format('YYYY-MM-DD')

  if (dayjs(nextMonth).isAfter(lastAvailableDate)) {
    return ['Calendar-nav--button--unavailable']
  }

  return []
}

const getMonths = (month) => {
  let monthNames = {
    'January': "janvier", 'February': "février", 'March': "mars", 'April': "avril", 'May': "mai", 'June': "juin", 'July': "juillet", 'August': "août", 'September': "septembre", 'October': "octobre", 'November': "novembre", 'December': "décembre"
  }
  return monthNames[month]
}

const YearMonth = ({ t, i18n }) => {
  const dispatch = useDispatch()
  const { date, firstAvailableDate, lastAvailableDate } = useSelector((state) => state.calendar)

  return (
    <section aria-label={t('calendar_navigation')} className="Calendar-nav">
      <button
        id="previous"
        className={['Calendar-nav--button', ...prevNav(date, firstAvailableDate)].join(' ')}
        type="button"
        aria-label={t('calendar_schedular.previous_month')}
        onClick={() => {
          dispatch(selectPreviousAction())
        }}
        tabIndex='-1'
      >
        &#10094;
      </button>
      <div className="Nav--month">{i18n.language === 'en' ? dayjs(date).format('MMMM') : getMonths(dayjs(date).format('MMMM'))}</div>
      <button
        id="next"
        className={['Calendar-nav--button', ...nextNav(date, lastAvailableDate)].join(' ')}
        type="button"
        aria-label={t('calendar_schedular.next_month')}
        onClick={() => {
          dispatch(selectNextAction())
        }}
      >
        &#10095;
      </button>
    </section>
  )
}

export default withTranslation('common')(YearMonth)
